var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.51 320.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#fff;stroke-width:10px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke-linecap:square;}.cls-3{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "216.51 75.5 216.51 315.21 5 315.21 5 5 146.01 5 216.51 75.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "75.5 33.2 33.2 33.2 33.2 75.5 75.5 75.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "89.6 33.2 89.6 61.4 103.7 75.5 103.7 75.5 117.81 61.4 117.81 33.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.01 75.5 216.51 75.5 146.01 5 146.01 75.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.2,
    y1: 117.8,
    x2: 188.31,
    y2: 117.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.2,
    y1: 160.11,
    x2: 188.31,
    y2: 160.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.2,
    y1: 202.41,
    x2: 188.31,
    y2: 202.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.2,
    y1: 244.71,
    x2: 188.31,
    y2: 244.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.2,
    y1: 287.01,
    x2: 188.31,
    y2: 287.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/CV.0ba83f3ef20d5faddbebc25cf3c0c49d.svg";
export { ForwardRef as ReactComponent };